import { Collapse, List, ListItemButton } from "@mui/material";
import { useEffect, useState } from "react";
import colorConfigs from "../../configs/colorConfigs";
import { RouteType } from "../../routes/config";
import SidebarItem from "./SidebarItem";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useTheme } from "../hooks/useTheme";


type Props = {
  item: RouteType,
};

const SidebarItemCollapse = ({ item }: Props) => {
  const { themeStyles } = useTheme();
  const [open, setOpen] = useState(false);

  const { appState } = useSelector((state: RootState) => state.appState);

  useEffect(() => {
    if (appState.includes(item.state)) {
      setOpen(true);
    }
  }, [appState, item]);

  return (
    item.sidebarProps ? (
      <>
        <ListItemButton
          onClick={() => setOpen(!open)}
          className="w-full flex p-[10px] items-center gap-2.5"
          sx={{
            "&: hover": {
              backgroundColor: appState === item.state ? colorConfigs.sidebar.activeBg : themeStyles.sideBar.menuItemsHoverColor
            },
            backgroundColor: appState === item.state ? colorConfigs.sidebar.activeBg : "unset",
            color: appState === item.state ? "#167AC3" : themeStyles.sideBar.menuItemsColor,
            padding: "10px",
          }}
        >
          <span className={`material-symbols-outlined ${appState === item.state ? 'text-[#167AC3]' : themeStyles.sideBar.tailwindMenuItemsColor} text-[25px] font-extralight`}>
            {item.sidebarProps.icon && item.sidebarProps.icon}
          </span>
          <span className={`${themeStyles.sideBar.tailwindMenuItemsColor} text-[13px] font-medium tracking-wide`}>
            {item.sidebarProps.displayText}
          </span>
          {open ? <span className={`material-symbols-outlined ${themeStyles.sideBar.tailwindMenuItemsColor} ml-auto text-[30px] font-extralight`}>
            arrow_drop_up
          </span> :
            <span className={`material-symbols-outlined ${themeStyles.sideBar.tailwindMenuItemsColor} ml-auto text-[30px] font-extralight`}>
              arrow_drop_down
            </span>}
        </ListItemButton>


        <Collapse className="w-full" in={open} timeout="auto">
          <List className="w-full">
            {item.child?.map((route, index) => (
              route.sidebarProps &&
                route.child ? (
                <SidebarItemCollapse item={route} key={index} />
              ) : (
                <SidebarItem item={route} key={index} />
              )
            ))}
          </List>
        </Collapse>
      </>
    ) : null
  );
};

export default SidebarItemCollapse;